import { createTemplateSnapshot } from './component-template'

export const SYSTEM_COMPONENT_CREATOR = '1199596756811550720'
export const systemComponentId = key => /^\d+:\d+$/.test(key) ? 'builtin_' + key.replace(':', '_') : ''
export function systemComponent (item) {
  const id = systemComponentId(item.key)
  let snapshot = null
  try { snapshot = createTemplateSnapshot([{ ...JSON.parse(JSON.stringify(item.option)), index: id, left: 0, top: 0 }]) } catch (_) { /* 未迁移类型仍可从原编辑器使用。 */ }
  return { id, resourceType: 'component', kind: 'component', name: item.label, visibility: 'public', creatorId: SYSTEM_COMPONENT_CREATOR, systemKey: item.key, snapshot, isSystem: true, registered: false, editable: false }
}
export function systemComponentOption (base, item) {
  if (!item || !item.snapshot || item.snapshot.nodes.length !== 1 || item.snapshot.nodes[0].children) return base
  return { ...JSON.parse(JSON.stringify(base)), ...JSON.parse(JSON.stringify(item.snapshot.nodes[0])) }
}
